module.exports = __webpack_public_path__ + "static/media/instagramInTouch.7e13ae8a.svg";